import { BreakpointObserver } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { of } from 'rxjs';
import { map, distinctUntilChanged, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ViewportService {

  constructor(
      private bo: BreakpointObserver,
      @Inject(PLATFORM_ID) private platformId: Object
    ) {}

    // Reactive stream: true if <= 768px
    readonly isMobile$ = isPlatformBrowser(this.platformId)
      ? this.bo.observe(['(max-width: 767.98px)']).pipe(
          map(result => result.matches),
          distinctUntilChanged(),
          shareReplay({ bufferSize: 1, refCount: true })
        )
      : of(false); // SSR-safe fallback

    // One-off synchronous check (use sparingly)
    isMobileSync(): boolean {
      return isPlatformBrowser(this.platformId)
        && window.matchMedia('(max-width: 767.98px)').matches;
    }

}
